<template>
  <div>
    <b-modal
      class="modal-form-event-training"
      id="modal-form-event-training"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
      size="l"
      :title="text"
    >
      <label>Name Event :</label>
      <b-form-input
        id="input-1"
        class="mb-4"
        v-model="form.title"
        placeholder="Enter name event/training"
        required
      ></b-form-input>
      <div>
        <label>Method :</label>
        <div>
          <b-select
            id="input-5"
            class="method mb-4 vertical-top"
            ref="optionMethod"
            v-model="form.method"
          >
            <option
              class="align-middle p-2"
              v-for="option in optionMethod"
              :key="option.value"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </b-select>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <label>Day Length : </label>
          <b-form-input
            id="input-3"
            class="mb-4"
            v-model="form.dayLength"
            placeholder="Enter partisipant"
            required
          ></b-form-input>
        </div>
        <div>
          <label>Budget :</label>
          <validation-provider
            name="Budget"
            rules="required|min_value:0"
            v-slot="{ errors }"
          >
            <b-form-group :invalid-feedback="errors[0]">
              <b-input-group
                prepend="Rp"
                :class="{ 'is-invalid': errors.length }"
              >
                <money
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  v-model="form.budget"
                  placeholder="0"
                />
              </b-input-group>
            </b-form-group>
          </validation-provider>
        </div>
      </div>
      <div class="d-flex">
        <div class="date-picker">
          <label>Start Date :</label>
          <b-form-datepicker
          id="input-6"
          class="mb-4"
          v-model="form.startDate"
          placeholder="Enter date"
          ></b-form-datepicker>
        </div>
        <div>
          <label class="ml-3">Start Time :</label>
          <b-form-timepicker class="time-picker" v-model="form.startTime" locale="en"></b-form-timepicker>
        </div>
      </div>
      <div class="d-flex">
        <div class="date-picker">
          <label>End Date :</label>
          <b-form-datepicker
            id="input-7"
            class="mb-4"
            v-model="form.endDate"
            placeholder="Enter end date plan"
            :state="isEndDateValid ? null : false"
          ></b-form-datepicker>
        </div>
        <div>
          <label class="ml-3">End Time :</label>
          <b-form-timepicker class="time-picker" v-model="form.endTime" locale="en"></b-form-timepicker>
        </div>
      </div>
      <p v-if="!isEndDateValid" class="text-danger">End Date must be greater than or equal to Start Date.</p>
      <div class="d-flex justify-content-between">
        <div>
          <label>Report :</label>
          <b-form-input
            id="input-4"
            class="mb-4"
            v-model="form.report"
            placeholder="Enter link report"
          ></b-form-input>
        </div>
        <div>
          <label>Status Paid :</label>
          <div>
            <b-select
              id="input-5"
              class="status-budget mb-4 vertical-top"
              ref="optionMethod"
              v-model="form.statusBudget"
            >
              <option
                class="align-middle p-2"
                v-for="option in paidStatusEvent"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </b-select>
          </div>
        </div>
      </div>
      <div>
        <b-form-textarea
          id="textarea"
          v-model="form.description"
          placeholder="Enter description events..."
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </div>
      <div class="mt-3 d-flex justify-content-center">
        <b-button
          class="text-white"
          variant="warning"
          type="submit"
          block
          @click="createEventTraining"
        >
          {{ variantForm }}
          <b-spinner
            v-if="isBusy"
            class="ml-1"
            label="Spinning"
            small
          />
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api'

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    modeUpdate: {
      type: Boolean,
      default: false
    },
    dataUpdate: {
      type: Object,
      default: () => {}
    },
    employee: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        title: '',
        budget: 0,
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        method: '',
        statusBudget: '',
        report: '',
        dayLength: '',
        description: ''
      },
      optionEmployees: [],
      optionMethod: [
        {
          value: true,
          text: 'Online'
        },
        {
          value: false,
          text: 'Offline'
        }
      ],
      paidStatusEvent: [
        {
          value: 0,
          text: 'Paid'
        },
        {
          value: 1,
          text: 'Pending'
        },
        {
          value: 2,
          text: 'None'
        }
      ],
      isBusy: false,
      hasAlphabetInput: false,
      messageRequest: {
        text: '',
        variantAlert: ''
      }
    }
  },
  computed: {
    variantForm() {
      return this.modeUpdate ? 'Update' : 'Create'
    },
    isEndDateValid() {
      if (this.form.startDate && this.form.endDate) {
        return this.form.endDate >= this.form.startDate
      }
      return true
    }
  },
  methods: {
    async createEventTraining() {
      const hasNullValue = Object.values(this.form).some(value => value === '')
      const isEndDateValid = this.form.endDate >= this.form.startDate
      if (hasNullValue) {
        this.isBusy = false
        this.$nextTick(() => {
          this.$bvToast.toast('Please fill all form fields', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      } else if (!isEndDateValid) {
        this.isBusy = false
        this.$nextTick(() => {
          this.$bvToast.toast('Please ensure that the End Date is valid', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      } else {
        const startDate = this.form.startDate.concat(' ', this.form.startTime)
        const endDate = this.form.endDate.concat(' ', this.form.endTime)
        if (this.modeUpdate) {
          try {
            this.isBusy = true
            await api.eventTraining.updateEvent(this.dataUpdate.id, {
              title: this.form.title,
              eventDetails: this.form.eventDetails,
              budget: this.form.budget,
              startDate: startDate,
              endDate: endDate,
              method: this.form.method,
              statusBudget: this.form.statusBudget,
              report: this.form.report,
              dayLength: this.form.dayLength,
              description: this.form.description
            })
            this.$bvModal.hide('modal-form-event-training')
            this.isBusy = false
            this.form = {
              title: '',
              eventDetails: [],
              budget: '',
              startDate: '',
              startTime: '',
              endDate: '',
              endTime: '',
              method: '',
              statusBudget: '',
              report: '',
              dayLength: '',
              description: ''
            }
            setTimeout(() => {
              this.$emit('refresh')
            }, 2000)
            this.sendResultToParent('Update Event success', 'success')
          } catch (error) {
            console.log(error)
          }
        } else {
          try {
            this.isBusy = true
            await api.eventTraining.create({
              title: this.form.title,
              eventDetails: this.form.eventDetails,
              budget: this.form.budget,
              startDate: startDate,
              endDate: endDate,
              method: this.form.method,
              statusBudget: this.form.statusBudget,
              report: this.form.report,
              dayLength: this.form.dayLength,
              description: this.form.description
            })
            this.$bvModal.hide('modal-form-event-training')
            setTimeout(() => {
              this.$emit('refresh')
            }, 2000)
            this.isBusy = false
            this.form = {
              title: '',
              eventDetails: [],
              description: '',
              budget: '',
              startDate: '',
              startTime: '',
              endDate: '',
              endTime: '',
              method: '',
              statusBudget: '',
              report: '',
              dayLength: ''
            }
            this.sendResultToParent('Create Event success', 'success')
          } catch (error) {
            console.log(error)
          }
        }
      }
    },
    seperateDateTime() {
      const [startDate, startTime] = this.dataUpdate.startDate.split(' ')
      const [endDate, endTime] = this.dataUpdate.endDate.split(' ')
      this.form.startDate = startDate
      this.form.startTime = startTime
      this.form.endDate = endDate
      this.form.endTime = endTime
    },
    sendResultToParent(message, variant) {
      this.messageRequest.text = message
      this.messageRequest.variantAlert = variant
      this.$emit('result-request', this.messageRequest)
    }
  },
  watch: {
    dataUpdate: {
      handler(oldValue) {
        this.form = { ...oldValue }
        this.seperateDateTime()
      },
      deep: true
    },
    employee: {
      handler() {
        const options = this.employee.filter((item, index, self) =>
          self.findIndex(obj => obj.fullName === item.fullName) === index
        )
        this.optionEmployees = options.map(item => item.fullName)
        this.optionEmployees.push('All')
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-form-event-training #input-1, #input-2, #input-3, #input-4, #input-5, #input-6, #input-7{
padding: 5px;
}

.date-picker{
  width: 35vh;
}

.time-picker{
  margin-left: 10px;
}

.status-budget{
  width: 33vh;
}
</style>
